<template>
     <div class="d-inline-block text-left dt-block">
        <p class="mb-1">{{label}}</p>
        <b-dropdown
            variant="link"
            toggle-class="text-decoration-none outline-none"
            class="mx-0 my-0 br-border"
            no-caret
        >
            <template v-slot:button-content>
                <div class="d-flex justify-content-between">
                    <span class="text-body">{{placeholder}}</span>
                    <span>
                        <SvgIcon name="chevron-down" direction="up"/>
                    </span>
                </div>
            </template>
            {{ /* SEE dev notes bellow on @click.native.capture.stop */ }}
            <b-dropdown-item
                event="hover"
                key="field-all-0"
                value="all"
                @click="resetSelected"
            >
                <span class="font-weight-bold">{{ $i18n.t('reports.all') }}</span>
            </b-dropdown-item>
            <b-dropdown-item
                event="hover"
                v-for="(field, index) in fields"
                :key="`field-${index}`"
                @click.native.capture.stop=""
            >
                <b-form-checkbox
                    v-model="selected"
                    :key="`c-box-${index}`"
                    :inline="true"
                    :value="field.value"
                    @change="$emit('change', $event)"
                >
                    {{ field.label }}
                </b-form-checkbox>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
    // components
    import SvgIcon from "../shared/SvgIcon";

    export default {
        name: "ReportsDropDown",
        data() {
            return {
                selected: []
            }
        },
        props: {
            data: Array,
            label: {
                type: String,
            },
            fields: {
                type: Array,
                default: () => []
            },
            placeholder: {
                type: String
            }
        },
        components: {
            SvgIcon
        },
        methods: {
            resetSelected() {
                this.$emit('change', []);
                this.selected = [];
            }
        }
    }
</script>

<style lang="scss" scoped>
    .dt-block {
        max-width: 160px;
    }

    .b-dropdown::v-deep {
        .dropdown-menu {
            overflow-x: auto;
        }
    }
</style>